import { IsOptional, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';
import { IsValidNumber, IsValidString, TimeWindow } from '@cnx-saas/common';
import { VehicleCapabilities } from '@cnx-saas/vehicles';
import {
  Article,
  LoadArticle,
  LoadInput,
  LoadLocation,
  Location,
  Order,
} from '../types';
import { ArticleInputValidationSchema } from './Article';
import { LocationInputValidationSchema } from './Location';

export class LoadArticleInputValidationSchema implements LoadArticle {
  @ValidateNested()
  @Type(() => ArticleInputValidationSchema)
  article: Article;

  @IsValidNumber({ integer: true, min: 1, max: 9999 })
  loadedQuantity: number;
}

class LoadLocationInputValidationSchema implements LoadLocation {
  @ValidateNested()
  @Type(() => LocationInputValidationSchema)
  location: Location;

  timeWindow: TimeWindow;
  order?: Order;

  @IsOptional()
  @ValidateNested({ each: true })
  @Type(() => LoadArticleInputValidationSchema)
  articles?: LoadArticle[];
}

export class LoadInputValidationSchema implements LoadInput {
  @IsValidString({ optional: true })
  externalReference?: string;

  @IsValidString({ optional: true })
  content?: string;

  @IsValidNumber({ integer: true, min: 1 })
  loadingMillimeter: number;

  @IsValidNumber({ min: 0.001 })
  weightInKg: number;

  loadingRequirements?: VehicleCapabilities[];

  @IsValidString({ optional: true, maxLength: 500 })
  additionalInfo?: string;

  @ValidateNested()
  @Type(() => LoadLocationInputValidationSchema)
  pickUp: LoadLocation;

  @ValidateNested()
  @Type(() => LoadLocationInputValidationSchema)
  dropOff: LoadLocation;
}
